import { ErrorBoundary } from '@/components/error-boundary';
import { Toaster } from '@/components/ui/sonner';
import WebLayoutTemplate from '@/components/web/layouts/web-layout-template';
import { LoginGateProvider } from '@/contexts/login-gate-provider';
import { type BreadcrumbItem } from '@/types';
import { type ReactNode } from 'react';

interface WebLayoutProps {
  children: ReactNode;
  breadcrumbs?: BreadcrumbItem[];
}

export default function WebLayout({ children, breadcrumbs, ...props }: WebLayoutProps) {
  return (
    <ErrorBoundary>
      <WebLayoutTemplate breadcrumbs={breadcrumbs} {...props}>
        <LoginGateProvider>
          {children}
          <Toaster position="top-right" theme="light" richColors />
        </LoginGateProvider>
      </WebLayoutTemplate>
    </ErrorBoundary>
  );
}
